import CustomInputNumber from "common/Inputs/CustomInputNumber";
import Flex from "common/Boxes/Flex";
import styled from "styled-components";
import Text from "common/Typography/Text";
import { useRef } from "react";
import { typography } from "@shared/common/Themes/typography";
import { openMessage } from "utils/misc";
import { getErrorDisplayMessage } from "@shared/features/trades/common/utils";
import { EditTradeInputProps } from "@shared/features/trades/EditTrade/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const EditTradeInput = ({
  mainValidationMessage,
  mainValidationMessageIsError,
  precision,
  name,
  value,
  onChange,
  inputPrefix,
  additionalErrors = [],
  focusOnMount,
  isSignal,
  disabledMessage,
}: EditTradeInputProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  const inputRef = useRef<HTMLInputElement>(undefined);

  return (
    <Wrapper
      $disabled={Boolean(disabledMessage)}
      onClick={
        disabledMessage
          ? () => {
              openMessage(disabledMessage, "warning");
            }
          : undefined
      }
    >
      <InputRowWrapper onClick={() => inputRef?.current?.focus()}>
        <Text type={"secondary"}>{name}</Text>
        <div>
          <Text as="span">{inputPrefix}</Text>
          <CustomInputNumber
            name={name}
            bordered={false}
            value={value}
            onChange={onChange}
            precision={precision}
            stringMode={true}
            placeholder={"0"}
            autoSize={true}
            focusOnMount={focusOnMount}
            innerRef={inputRef}
            disabled={Boolean(disabledMessage)}
            style={{
              background: "transparent",
              paddingLeft: 0,
              paddingRight: 0,
            }}
            focusDelay={400}
          />
        </div>
      </InputRowWrapper>
      <Text
        $size={typography.fontSizes.S}
        type={mainValidationMessageIsError ? "danger" : "primary"}
      >
        {mainValidationMessage}
      </Text>
      {additionalErrors.length > 0 && (
        <Text $size={typography.fontSizes.S} type={"danger"}>
          {getErrorDisplayMessage(t, additionalErrors[0], undefined, isSignal)}
        </Text>
      )}
    </Wrapper>
  );
};

export default EditTradeInput;

const InputRowWrapper = styled(Flex)`
  width: 100%;
  border-bottom: ${(p) => p.theme.borders.lightest};
  margin-bottom: 4px;
  cursor: pointer;
  color: ${(p) => p.theme.colors.textColor};
`;
const Wrapper = styled.div<{ $disabled?: boolean }>`
  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
  ${(p) =>
    p.$disabled
      ? `opacity: 0.3;
     user-select:none;
     input {
        pointer-events: none;
     }`
      : ""}
`;
